<template>
    <div>
        <b-carousel id="carousel1"
                    style="text-shadow: 1px 1px 2px #333;"
                    controls
                    indicators
                    background="#ababab"
                    :interval="4000"
                    img-width="1920"
                    img-height="963"
                    v-model="slide">
            <b-carousel-slide v-for="carouselItem in slides" :key="slide.name">
                <img slot="img" class="d-block img-fluid w-100" width="1920" height="963" :src="carouselItem.image"
                     :alt="carouselItem.title">
                <h1>{{carouselItem.title}}</h1>
                <p class="d-none d-md-block">{{carouselItem.text}}</p>
            </b-carousel-slide>
        </b-carousel>
        <div class="jumbotron">
            <div class="container">
                <img src="./../assets/images/logobiale-lg.png" width="400" class="img-fluid mx-auto d-block pt-2"/>
                <hr>
                <div class="row">
                    <div class="col pt-3 pb-3">
                        <img src="./../assets/Entypo+/tools.svg" width="50" height="50"
                             class="img-fluid mx-auto d-block pt-3 pb-3"/>
                        <p class="text-center">
                            Fahu Meble to stolarnia, z którą zrealizujesz, nawet najbardziej wyszukane projekty</p>
                        <router-link :to="{name: 'projects'}" class="btn btn-dark mx-auto btn-block d-lg-none">
                            Kliknij i zobacz nasze projekty
                        </router-link>
                    </div>
                    <div class="col pt-3 pb-3">
                        <img src="./../assets/Entypo+/clock.svg" width="50" height="50"
                             class="img-fluid mx-auto d-block pt-3 pb-3"/>
                        <p class="text-center">Fahu Meble to gwarancja punktualności</p>
                        <router-link :to="{name: 'contact'}" class="btn btn-dark mx-auto btn-block d-lg-none">
                            Kliknij i skontaktuj się z nami
                        </router-link>
                    </div>
                    <div class="col pt-3 pb-3">
                        <img src="./../assets/Entypo+/trophy.svg" width="50" height="50"
                             class="img-fluid mx-auto d-block pt-3 pb-3"/>
                        <p class="text-center">W Fahu Meble współpracujemy z najlepszymi dla najlepszych</p>
                        <router-link :to="{name: 'offer'}" class="btn btn-dark mx-auto btn-block d-lg-none">
                            Kliknij i zobacz ofertę dla specjalistów
                        </router-link>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4 d-none d-lg-block">
                        <router-link :to="{name: 'galleries'}" class="btn btn-dark mx-auto btn-block">
                            Kliknij i zobacz nasze projekty
                        </router-link>
                    </div>
                    <div class="col-4 d-none d-lg-block">
                        <router-link :to="{name: 'contact'}" class="btn btn-dark mx-auto btn-block">
                            Kliknij i skontaktuj się z nami
                        </router-link>
                    </div>
                    <div class="col-4 d-none d-lg-block">
                        <router-link :to="{name: 'offer'}" class="btn btn-dark mx-auto btn-block">
                            Kliknij i zobacz ofertę dla specjalistów
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <contact-page></contact-page>
    </div>
</template>

<script>
import ContactPage from './ContactPage.vue';

import foto1 from '../assets/images/DSC_2836.jpg';
import foto2 from '../assets/images/DSC_9013.jpg';
import foto3 from '../assets/images/kolaz.jpg';

export default {
  components: {
    ContactPage,
  },
  data() {
    return {
      slide: 1,
      slides: [
        {
          title: '', text: '',
          image: foto1,
        },
        {
          title: '', text: '',
          image: foto2,
        },
        {
          title: '', text: '',
          image: foto3,
        },
      ],
    };
  },
};
</script>

